<template>
  <v-footer class="font-weight-medium">
    <v-col cols="12">
      <small><strong>Hemoce</strong> - Sistema Administrativo - &copy; 2021 IPH - Sistemas</small>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
